/*  UI  */
import { Button, IconWithVariant } from '@auviknetworks/iceberg-ui';

/*  Shared  */
import { Dropdown } from 'application/Shared/Dropdown';
import { Item } from 'application/Shared/Dropdown/Menu';

/*  Packages  */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useDashboardContext } from './DashboardContext';
import { Meta } from './types';

/**
 * Settings component for the dashboard.
 */
export const Settings = () => {
    const { t } = useTranslation();
    const {
        schema,
        dashboardState: { refreshDashboard, autoAdjust },
        setRefreshDashboard,
        setAutoAdjust,
        setShowAbout
    } = useDashboardContext();

    const { refresh, editable } = schema.meta as Meta;

    const menu: Item[] = [
        refresh
            ? {
                  action: () =>
                      setRefreshDashboard(
                          refreshDashboard ? null : refresh ?? null
                      ),
                  labelKey: refreshDashboard
                      ? 'Dashboard.Settings.PauseRefresh'
                      : 'Dashboard.Settings.ResumeRefresh',
                  type: 'leaf'
              }
            : undefined,
        { labelKey: 'Layout', type: 'header' },
        {
            action: () => setAutoAdjust(!autoAdjust),
            labelKey: 'Dashboard.Settings.AutoAdjust',
            prefix: autoAdjust ? 'Check' : undefined,
            type: 'leaf'
        },
        {
            action: () => setShowAbout(true),
            labelKey: 'Dashboard.About',
            type: 'leaf'
        },
        editable
            ? {
                  action: () => null,
                  labelKey: 'Common.edit',
                  type: 'leaf'
              }
            : undefined
    ].filter(Boolean) as Item[];

    return (
        <Dropdown labelKey="Options" menu={menu}>
            <Button
                data-trackid="dashboard_settings_menu"
                variant="iconWithoutBorder"
                size="icon"
                textStyle="greyIcon"
                title={t('Dashboard.settings')}
            >
                <IconWithVariant src="Menu" size="14px" />
            </Button>
        </Dropdown>
    );
};
